// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-button.dc-btn[data-v-48148542]{border:1px solid rgba(0,0,0,0);background:rgba(0,0,0,0);-webkit-box-shadow:none;box-shadow:none;-webkit-transition:color .1s linear;transition:color .1s linear;color:#26aafe}.edit-button.dc-btn[data-v-48148542]:hover{border:1px solid rgba(0,0,0,0);background:rgba(0,0,0,0);-webkit-box-shadow:none;box-shadow:none;color:#1e87cb}", ""]);
// Exports
module.exports = exports;
